import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { getMultipleAssets } from '@/services/asset.service';
import { QueryKey } from '@/lib/queryKeys';

export const useMultipleAsset = (
  form: {
    reset: (data: any) => void;
  },
  folderId?: string,
  albumId?: string,
  assetIds?: Array<string>,
  includeSubFolderAssets?: boolean,
  searchQuery?: string,
  options?: object,
) => {
  const getMultipleAssetsFn = useAuthenticatedQueryFn(getMultipleAssets);

  const {
    data: multipleAssets,
    isLoading: isMultipleAssetLoading,
    isPending: isMultipleAssetPending,
    isFetching: isMultipleAssetFetching,
    error: multipleAssetError,
    refetch: refetchMultipleAsset,
  } = useQuery({
    queryKey: [QueryKey.MultipleAssets, folderId, albumId, assetIds, ...(folderId ? [includeSubFolderAssets] : [])],
    queryFn: async () => {
      const data = await getMultipleAssetsFn({ folderId, albumId, assetIds, searchQuery, includeSubFolderAssets });
      form?.reset(data);
      return data;
    },
    ...options,
  });

  return {
    multipleAssets,
    refetchMultipleAsset,
    isMultipleAssetLoading,
    isMultipleAssetPending,
    isMultipleAssetFetching,
    multipleAssetError,
  };
};
